//数组对象去重
import { getUserInfo, getToken } from './auth';

export function removeDuplicateObj(arr) {
    let newArr = [];
    let obj = {};
    for (let i = 0; i < arr.length; i++) {
        if (!obj[arr[i].country]) {
            newArr.push(arr[i]);
            obj[arr[i].country] = true;
        }
    }
    return newArr;
}

export function getRoleRedirect(role) {
    if (role === 'ca') {
        return '/clientAdmin/home';
    }
    if (role === 'admin' || role === 'pa' || role === 'da') {
        return '/companyList';
    }
    if (role === 'participant') {
        return '/clientPage/engagement';
    }
    return '/';
}

export function getLoginRedirect(role) {
    if (role === 'admin' || role === 'pa' || role === 'da') {
        return '/admin';
    }
    if (role === 'ca') {
        return '/client';
    }
    return '/';
}

export function resolveLoginRedirect() {
    const userInfo = getUserInfo();
    const role = (userInfo && userInfo.roles && userInfo.roles[0] && userInfo.roles[0].roleKey)
        || localStorage.getItem('lastRole');
    if (role) {
        localStorage.setItem('lastRole', role);
    }
    return getLoginRedirect(role);
}

export function resolveHomeRedirect() {
    const userInfo = getUserInfo();
    if (!getToken() || !userInfo) {
        return resolveLoginRedirect();
    }
    const role = (userInfo.roles && userInfo.roles[0] && userInfo.roles[0].roleKey)
        || localStorage.getItem('lastRole');
    return getRoleRedirect(role);
}

//把url传参变为对象
export function param2Obj(url) {
    const search = url.split('?')[1];
    if (!search) {
        return {}
    }
    return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
}

// get下载
export function downloadFromBlob(response, defaultFileName) {
    let fileName = null;
    const contentDisposition = response.headers['content-disposition'];

    if (contentDisposition) {
        // 解析 filename
        const matchRfc5987 = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
        if (matchRfc5987) {
            fileName = decodeURIComponent(matchRfc5987[1]);
        } else {
            // 带双引号的 filename
            const matchQuoted = contentDisposition.match(/filename="([^"]+)"/);
            if (matchQuoted) {
                fileName = decodeURIComponent(matchQuoted[1]);
            } else {
                // 解析无引号的 filename
                const matchUnquoted = contentDisposition.match(/filename=([^;]+)/);
                if (matchUnquoted) {
                    fileName = decodeURIComponent(matchUnquoted[1].trim());
                }
            }
        }
    }


    const finalFileName = fileName || defaultFileName || `download-${new Date().getTime()}`;

    const blob = new Blob([response.data]);

    if ('download' in document.createElement('a')) {
        // 非IE浏览器
        const link = document.createElement('a');
        link.download = finalFileName;
        link.href = URL.createObjectURL(blob);
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
    } else {
        // IE10+ 浏览器
        navigator.msSaveBlob(blob, finalFileName);
    }
}
